/* global _ */

import './vendor/pushstream';
import './vendor/lodash.custom.min';

import Fetch from './modules/fetch';
import Polling from './modules/polling';
import Stream from './modules/stream';
import getCustomLogger from './modules/logger';

import { isMobile, nodeListToArray, formataData, formataPorcentagem, inserirPontuacaoMilhar, waitUntil } from './utils';

import { setEnv } from './modules/settings';


const REQUEST_TYPE_MAP = {
  POLLING: 'poll',
  STREAM: 'push'
};

var dummyErrorCallback = function () {};
const logger = getCustomLogger();


class ApuracaoBase {
  constructor(options) {
    const defaultOptions = {
      container: null,
      containerResumo: null,
      url: null,
      start: true,
      polling: true,
      itemsPerPage: 10,
      updateFrequency: 15,
      templates: {},
      highPriority: true,
      env: 'prod',
    };

    Object.assign(defaultOptions, options);

    setEnv(defaultOptions.env);

    this.options = defaultOptions;
    this.options.polling = window.location.hash !== '#debug' && this.options.polling;

    this.containerEl = this.options.container;
    this.parentContainerEl = this.options.parentContainer;

    this.elements = {};
    this._dados = {}; // variável de referência contendo os dados da apuracao.
    this._requestType = this.options.pushStream ? REQUEST_TYPE_MAP.STREAM : REQUEST_TYPE_MAP.POLLING;

    this.errorCallback = this.options.error || dummyErrorCallback;

    this.compileTemplate();

    if (this.options.start) {
      this.start();
    }

    return this;
  }

  start() {
    if (this.containerEl instanceof Node) {
      this.elements.atualizacaoContainer = this.containerEl.querySelector('.js-eui-timer');
      this.elements.timer = this.containerEl.querySelector('.js-eui-timer__countdown');
    } else if (this.containerEl instanceof Array && this.parentContainerEl) {
      this.elements.atualizacaoContainer = this.parentContainerEl.querySelector('.js-eui-timer');
      this.elements.timer = this.parentContainerEl.querySelector('.js-eui-timer__countdown');
    }

    this.hasTimer = this.elements.timer && this.elements.atualizacaoContainer;

    const fetcher = new Fetch(this.options.url, this.successCallback.bind(this), this.errorCallback.bind(this));
    fetcher.request();

    if (this._requestType === REQUEST_TYPE_MAP.STREAM) {
      this.startStream();
    } else {
      this.startPolling();
    }
  }

  startPolling() {
    this._requestType = REQUEST_TYPE_MAP.POLLING;

    if (this.polling) {
      if(!this.polling.isPollEnabled()) {
        logger.info('Restarting polling data update for url', this.options.url);

        this.polling.start();
      }
    } else {
      logger.info('Starting polling data update for url', this.options.url);

      this.polling = new Polling(
        this.options.url,
        this.options.updateFrequency,
        this.successCallback.bind(this),
        this.errorCallback.bind(this),
        this.counterCallback.bind(this)
      );
    }
  }

  startStream() {
    this._requestType = REQUEST_TYPE_MAP.STREAM;

    if (!this.stream) {
      logger.info('Starting PushStream data update for channel', this.options.pushStream['channel']);

      this.stream = new Stream(
        this.options.pushStream['url'],
        this.options.pushStream['port'] || 80,
        this.options.pushStream['channel'],
        this.successCallback.bind(this), // running callback
        this.startPolling.bind(this), // onError callback
        this.stopPolling.bind(this) // onStarted callback
      );
    }
  }

  stopPolling() {
    if (this.polling) {
      logger.info('Stopping polling data update for url', this.options.url);

      this.polling.stop();
    }
  }

  stopStream() {
    if (this.stream) {
      logger.info('Stopping PushStream data update for channel', this.options.pushStream['channel']);

      this.stream.disconnect();
    }
  }

  manageRequestType(requestType) {
    if (requestType !== this._requestType) {
      if (requestType === REQUEST_TYPE_MAP.POLLING) {
        this.stopStream();
        this.startPolling();
      }
      /* Deveriamos fazer a mudança de Polling para Stream?
      else if (requestType === REQUEST_TYPE_MAP.STREAM) {
        this.stopPolling();
        this.startStream();
      }
      */
    }
  }


  compileTemplate() {
    const templates = this.options.templates;
    for (let key in templates) {
      if (Object.prototype.hasOwnProperty.call(templates, key) && templates[key].templateSelector) {
        let templateEl = document.querySelector(templates[key].templateSelector);

        if (!templateEl) {
          logger.error('Template not found: ', templates[key].templateSelector);
        } else {
          this.options.compiledTemplates[key] = _.template(templateEl.innerHTML);
        }
      }
    }

    return this;
  }

  estaFinalizada() {
    if (this._dados && typeof this._dados.abrangencia !== 'undefined') {
      return this._dados.abrangencia.totalizacaoFinal;
    }
    return false;
  }

  setErrorCallBack(callback) {
    this.options.error = callback;
  }

  successCallback(data) {
    this._dados = data;

    if (this.estaFinalizada()) {
      logger.info('Finished, stopping data update');

      this.stopPolling();
      this.stopStream();
    }

    this.manageRequestType(this._dados.requestType);

    const render = () => {
      logger.debug('Rendering', this._dados, 'into', this.containerEl);

      this.atualizarUpdateFrequency(this._dados);
      this.atualizarDataCrashStatus(this._dados);
      this.atualizarTemplate();
      this.animarBarrinhas();
    };

    if (this.options.highPriority || !isMobile) {
      render();
    } else {
      waitUntil(this.isInFocus.bind(this), this.options.updateFrequency).then(render);
    }
  }

  counterCallback(countdownTimer) {
    if (this.hasTimer) {
      this.elements.timer.textContent = countdownTimer < 10 ? '0' + countdownTimer : countdownTimer;
    }
  }

  atualizarTemplate() {
    let currentTemplateOptions;
    let matchedFunction;

    for (var currentTemplateName in this.options.templates) {
      currentTemplateOptions = this.options.templates[currentTemplateName];
      matchedFunction = this[currentTemplateName];

      if (matchedFunction && typeof matchedFunction === 'function') {
        matchedFunction.call(this, this._dados, currentTemplateName, currentTemplateOptions);
      } else {
        this.renderTemplate(this._dados, currentTemplateName, currentTemplateOptions);
      }
    }
  }

  renderTemplate(data, currentTemplateName, templateOptions) {
    const tmpl = this.options.compiledTemplates[currentTemplateName];

    if (!tmpl) {
      logger.warn(
        `Template ${currentTemplateName} not found at compiled templates.`,
        'New data will not be rendered.'
      );
    } else {
      const resultHTML = tmpl(data),
        elementList = this.containerEl.querySelectorAll(templateOptions.selector);

      if (elementList.length !== 0) {
        nodeListToArray(elementList).forEach(function (element) {
          element.innerHTML = resultHTML;
        });
      } else {
        logger.warn(
          `Elements with selector ${templateOptions.selector} not found in`,
          this.containerEl,
          `Template ${currentTemplateName} result has no container to be render.`
        );
      }
    }
  }

  isInFocus() {
    const containerPosition = this.containerEl.getBoundingClientRect();
    return (
      (containerPosition.height > 0 || containerPosition.width > 0) &&
      containerPosition.bottom >= 0 &&
      containerPosition.right >= 0 &&
      containerPosition.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      containerPosition.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  atualizarUpdateFrequency(dados) {
    if (dados && this.polling) {
      this.polling.setInterval(dados.pollingInterval);
    }
  }

  atualizarDataCrashStatus(dados) {
    const dataCrashClassName = 'js-apuracao-data-crash';
    if (this.containerEl instanceof Node) {
      if (dados.abrangencia.aguardandoApuracao) {
        this.containerEl.classList.add(dataCrashClassName);
      } else {
        this.containerEl.classList.remove(dataCrashClassName);
      }
    }
  }

  atualizaAndamento(dados, templateName, templateOptions) {
    const novosDados = {
      abrangencia: {
        andamento: 0,
      },
    };

    novosDados.abrangencia.andamento = formataPorcentagem(dados.abrangencia.andamento);
    novosDados.abrangencia.aguardandoApuracao = dados.abrangencia.aguardandoApuracao;

    this.renderTemplate(novosDados, templateName, templateOptions);
  }

  resumoVotacao(dados, templateName, templateOptions) {
    const resumo = dados.abrangencia.votos,
      resumoFormatado = {};

    for (let key in resumo) {
      if (typeof resumo[key] === 'object') {
        resumoFormatado[key] = {
          quantidade: inserirPontuacaoMilhar(resumo[key].quantidade),
          porcentagem: formataPorcentagem(resumo[key].porcentagem),
        };
      }
    }
    this.renderTemplate(resumoFormatado, templateName, templateOptions);
  }

  ultimaAtualizacao(dados, templateName, templateOptions) {
    if (dados.abrangencia.totalizacaoFinal) {
      let dataHora = dados.dataHora.split('T'),
        ultima = {};

      ultima.data = formataData(dataHora[0]);
      ultima.hora = dataHora[1];

      this.renderTemplate(ultima, templateName, templateOptions);
    } else if (dados.abrangencia.matDefinido && this.elements.atualizacaoContainer) {
      this.elements.atualizacaoContainer.classList.add('eui-timer-piano--green');
    }
  }

  animarBarrinhas() {
    const porcentagem = this.getAndamento() + '%';
    const barras = this.containerEl.querySelectorAll('.js-glb-widget__progress');

    nodeListToArray(barras).forEach((barra) => {
      if (this._dados.abrangencia.matDefinido) {
        barra.classList.add('eui-progress-bar__status--green');
      }
      barra.style.width = porcentagem;
      void barra.offsetWidth; // precisa forcar o reflow, se nao, a barrinha nao anima
    });
    return this;
  }

  getAndamento() {
    const abrangencia = this._dados.abrangencia;
    return abrangencia.aguardandoApuracao ? 0 : abrangencia.andamento;
  }
}

export default ApuracaoBase;
